import { lazy } from 'react';

// Types
import { StripeWalletEligibleProps } from './StripeWalletEligible.types';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "StripeWalletEligible" */ './StripeWalletEligible')),
);

const LazyComponentWithSuspense = withSuspense<StripeWalletEligibleProps>(LazyComponent, 'StripeWalletEligible');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as StripeWalletEligible };
